<div class="snackbar" [@snack]="snackVisibility">
  {{ message }}
</div>